import React, { Component } from "react";
// import { Auth, I18n } from "aws-amplify";
import { Form, Input, FormGroup, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label } from "reactstrap";
import { Alert } from "antd";
import IntlMessages from "../../helpers/IntlMessages";

export default class CustomPasswordChange extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: props.password,
      oldPassword: props.oldPassword,
      isChanging: props.isChanging,
      confirmPassword: props.confirmPassword
      // alert: false,
    };
  }

  validateForm() {
    return this.props.oldPassword.length > 0 && this.props.password.length > 0 && this.props.password === this.props.confirmPassword;
  }

  //   handleChange = event => {
  //     this.setState({
  //       [event.target.id]: event.target.value
  //     });
  //   };

  //   message = () => {
  //     message.success('This is a success message');
  //     this.setState({
  //         messageAlert:true,
  //     })
  //   }

  render() {
    const messageSuccess = <IntlMessages id="user.passwordChangeSuccess" />;
    const messageError = <IntlMessages id="user.passwordChangeError" />;
    return (
      <div>
        <Modal isOpen={this.props.modal} toggle={this.props.toggle}>
          <ModalHeader toggle={this.props.toggle}>
            <IntlMessages id="user.modalChangePassword" />
          </ModalHeader>
          <ModalBody>
            <Form id="passwordChangeForm" onSubmit={this.props.handleChangeClick}>
              <FormGroup>
                {this.props.modalAlert === true && this.props.isChanging === true && !this.props.error ? (
                  <div>
                    <Alert description={messageSuccess} type="success" showIcon />
                  </div>
                ) : this.props.isChanging === false && this.props.error ? (
                  <Alert description={messageError} type="error" showIcon />
                ) : (
                  <div />
                )}
              </FormGroup>
              <FormGroup>
                <Label>
                  <IntlMessages id="user.oldPassword" />
                </Label>
                <Input type="password" id="oldPassword" onChange={this.props.handleChange} value={this.props.oldPassword} />
              </FormGroup>
              <hr />
              <FormGroup>
                <Label>
                  <IntlMessages id="user.newPassword" />
                </Label>
                <Input type="password" id="password" value={this.props.password} onChange={this.props.handleChange} />
              </FormGroup>
              <FormGroup>
                <Label>
                  <IntlMessages id="user.confirmPassword" />
                </Label>
                <Input type="password" id="confirmPassword" onChange={this.props.handleChange} value={this.props.confirmPassword} />
              </FormGroup>
              {/* <Button
            block
            type="submit"
            bsSize="large"
            text="Change Password"
            loadingText="Changing…"
            disabled={!this.validateForm()}
            isLoading={this.state.isChanging}
          /> */}
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" form="passwordChangeForm" block key="submit" type="submit" disabled={!this.validateForm()}>
              <IntlMessages id="user.changePassword" />
            </Button>{" "}
            <Button color="secondary" onClick={() => this.props.toggle()}>
              <IntlMessages id="user.cancel" />
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
